module.exports = __webpack_public_path__ + "img/cross-middle-image.532bb643.png";